/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Agent_Passkeys_DescriptionInputs */



/**
* | output |
* | --- |
* | "Accounts your AI agent has signed up for while browsing. It registers and uses these on its own; they are not your passkeys and cannot sign you in." |
*
* @param {Profile_Security_Agent_Passkeys_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_agent_passkeys_description = /** @type {((inputs?: Profile_Security_Agent_Passkeys_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Agent_Passkeys_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konten, für die sich Ihre KI beim Surfen registriert hat. Sie legt diese selbst an und verwendet sie eigenständig; es sind nicht Ihre Passkeys und sie können Sie nicht anmelden.")
	return /** @type {LocalizedString} */ ("Accounts your AI agent has signed up for while browsing. It registers and uses these on its own; they are not your passkeys and cannot sign you in.")
});